import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-route404',
    templateUrl: './route404.component.html',
    styleUrls: ['./route404.component.scss'],
})
export class Route404Component implements OnInit {
    constructor() {}

    ngOnInit() {}
}
